import _implicitStylesheets from "./targetTabset.css";

import _implicitScopedStylesheets from "./targetTabset.scoped.css?scoped=true";

import _myQueuedView from "my/queuedView";
import _lightningTab from "lightning/tab";
import _myDeployedView from "my/deployedView";
import _myErrorView from "my/errorView";
import _lightningTabset from "lightning/tabset";
import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element} = $api;
  const {_m0} = $ctx;
  return [api_custom_element("lightning-tabset", _lightningTabset, {
    classMap: {
      "target-tabset_align": true
    },
    attrs: {
      "data-my-id": "target-tabset"
    },
    props: {
      "variant": "scoped"
    },
    key: 0
  }, [api_custom_element("lightning-tab", _lightningTab, {
    classMap: {
      "target-tabset__height": true
    },
    props: {
      "label": $cmp.queuedTabTitle
    },
    key: 1
  }, [$cmp.showQueuedView ? api_custom_element("my-queued-view", _myQueuedView, {
    classMap: {
      "target-tab__height": true
    },
    props: {
      "selectedItems": $cmp.queuedItems,
      "validatedItems": $cmp.validatedItems,
      "nonDuplicateValidatedItems": $cmp.nonDuplicateValidatedItems,
      "updatedSelectedItems": $cmp.updatedSelectedItems,
      "disableDeploy": $cmp.disableDeploy,
      "disableValidate": $cmp.disableValidate,
      "disableOverwrite": $cmp.disableOverwrite
    },
    key: 2,
    on: {
      "clearqueuedcount": _m0 || ($ctx._m0 = api_bind($cmp.clearQueuedCount))
    }
  }, []) : null]), api_custom_element("lightning-tab", _lightningTab, {
    classMap: {
      "target-tabset__height": true
    },
    props: {
      "label": $cmp.deployedTabTitle
    },
    key: 3
  }, [api_custom_element("my-deployed-view", _myDeployedView, {
    classMap: {
      "target-tab__height": true
    },
    props: {
      "items": $cmp.deployedItems
    },
    key: 4
  }, [])]), api_custom_element("lightning-tab", _lightningTab, {
    classMap: {
      "target-tabset__height": true
    },
    props: {
      "label": $cmp.errorTabTitle
    },
    key: 5
  }, [api_custom_element("my-error-view", _myErrorView, {
    classMap: {
      "target-tab__height": true
    },
    props: {
      "items": $cmp.erroredItems
    },
    key: 6
  }, [])])])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "my-targetTabset_targetTabset"
